import React from 'react';
import FeatureFlags from './FeatureFlags';

const FeatureFlagContext = React.createContext<FeatureFlags>(new FeatureFlags());

export const FeatureFlagProvider = FeatureFlagContext.Provider;
export const FeatureFlagConsumer = FeatureFlagContext.Consumer;

export default FeatureFlagContext;
